// extracted by mini-css-extract-plugin
module.exports = {"button":"Checkbox_button__2LmyI","checkmark":"Checkbox_checkmark__bvPLv","title":"Checkbox_title__JLUwb","error":"Checkbox_error__qe1Qe"};